import React, { useState, useEffect, useMemo, useCallback } from "react";
import RawHoney from "../../assets/images/honey-wooden-table-min.jpg";
import ProcessedHoney from "../../assets/images/honey.jpg";
import SemiProcessedHoney from "../../assets/images/semi-processed-honey.jpg";
import Title from "../../components/titles/Title";
import FilterSort from "../../components/FilterSort/FilterSort";
import { Circles } from "react-loader-spinner";
import { useParams } from "react-router-dom";
import MainService from "../../common/MainService";
import { NavHashLink } from "react-router-hash-link";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";

export default function Honey() {
  const { subId } = useParams(); // Extracting subcategory ID from URL parameters
  const [loding, setLoading] = useState(true); // State to manage loading status
  const [getHoneyProducts, setHoneyProducts] = useState([]); // State to store honey products

  const [subCategory, setSubCategory] = useState([]); // State to store available subcategories
  const [getSubCategoryValue, setSubCategoryValue] = useState(""); // State to store the selected subcategory value

  // Effect to set subcategory value when subId changes
  useMemo(() => {
    if (subId !== "null") {
      setSubCategoryValue(subId);
    }
  }, [subId]);

  const user = `${window.livasaConfig.user}`; // Fetching user from global config

  // Function to fetch honey products based on the selected subcategory
  const getProductsHandler = useCallback(() => {
    MainService.productModelBasedonSubcategory(
      `${window.livasaConfig.categoryId}`,
      getSubCategoryValue,
      user
    )
      .then((res) => {
        setHoneyProducts(res); // Updating product state with API response
        setLoading(false); // Disabling loader after data is fetched
      })
      .catch((err) => {
        console.log("Error", err); // Handling API errors
      });
  }, [getSubCategoryValue, user]);

  // Function to fetch all available subcategories
  const getAllSubCategory = useCallback(() => {
    MainService.getSubCategories(user, `${window.livasaConfig.categoryId}`)
      .then((res) => {
        setSubCategory(res.contentsubcategories); // Storing fetched subcategories in state
        if (!subId) {
          setSubCategoryValue(
            res.contentsubcategories[0].contentsubcategoryname
          ); // Setting default subcategory if none is selected
        }
      })
      .catch((e) => {
        console.log("err"); // Handling API errors
      });
  }, [user, subId]);

  // Fetching products and subcategories when the component mounts or dependencies change
  useEffect(() => {
    getProductsHandler();
    getAllSubCategory();
  }, [getSubCategoryValue, getProductsHandler, getAllSubCategory]);

  // Mapping subcategory names to images
  const subcategoryImageMapping = {
    "Processed-Honey": ProcessedHoney,
    "Semi-Processed-Honey": SemiProcessedHoney,
    "Raw-Honey": RawHoney,
  };
  const defaultImageUrl = RawHoney; // Default image if no match is found

  return (
    <>
      <div className="container collection-container">
        {/* Section for displaying collections */}
        <Title heading="Collections" classname="mb-4" />
        <Row>
          {!loding ? (
            <>
              {/* Looping through subcategories and displaying them */}
              {subCategory.map((data, index) => {
                const imageUrl =
                  subcategoryImageMapping[data.contentsubcategoryname] ||
                  defaultImageUrl;
                return (
                  <Col md={6} lg={3} key={index}>
                    <NavHashLink
                      key={data.contentsubcategoryname}
                      to={`/collections/products/${data.contentsubcategoryname}/#products`}
                      onClick={() => {
                        setSubCategoryValue(data.contentsubcategoryname);
                      }}
                      className={({ isActive }) =>
                        isActive ? "active-link" : ""
                      }
                    >
                      <div className="card-container">
                        {/* Displaying subcategory image */}
                        <div className="card-image-container mb-4">
                          <img
                            src={imageUrl}
                            alt={data.contentsubcategoryname}
                          />
                        </div>
                        {/* Displaying subcategory name */}
                        <div>
                          <h5 className="text-center">
                            {data.contentsubcategoryname}
                          </h5>
                        </div>
                      </div>
                    </NavHashLink>
                  </Col>
                );
              })}
            </>
          ) : (
            // Display loader while fetching data
            <div className="justify-content-center d-flex">
              <Circles
                type="TailSpin"
                color="orange"
                height={70}
                width={70}
                timeout={5000}
              />
            </div>
          )}
        </Row>

        {/* Section for displaying products */}
        <div className="pt-5" id="products"></div>
        <Title heading="Products" classname="mb-5 pt-5" />
        <FilterSort obj={getHoneyProducts} loadValue={loding} />
      </div>
    </>
  );
}
